<app-custom-table-header [data]="data" [isEditingAll]="isEditingAll" [showImportButton]="showImportButton"
    [showImportFileButton]="showImportFileButton" [isSettingsOpen]="isSettingsOpen" [columnsCopy]="columnsCopy"
    [schemaName]="schemaName" [tableVerticleView]="tableVerticleView" [enableSummary]="enableSummary"
    [enableAdjustment]="enableAdjustment" (settingsClicked)="openSettings()" (editClicked)="startEditAll()"
    (saveClicked)="saveAllEdits()" (cancelClicked)="cancelEditAll()" (searchClicked)="openImportModal()"
    (fileUploaded)="handleFileUpload($event)" (applySettingsClicked)="applySettings($event)"
    (settingsClosed)="isSettingsOpen = false" />



<!-- Vertical table -->
<ng-container >
    <app-google-maps [locationDetails]="locationCoordinates" [zoom]="6" *ngIf="showMap"></app-google-maps >
<div class="table-responsive" *ngIf="isVerticalTable">
    <clr-datagrid>
        <clr-dg-column>Fields</clr-dg-column>
        <clr-dg-column *ngIf="defaultData && objectKeys(defaultData).length">Subject</clr-dg-column>
        <clr-dg-column *ngFor="let row of data; let i = index;">
            <span *ngIf="verticleTableHeaderTitle">{{ verticleTableHeaderTitle + ' ' + (i + 1) }}
            </span>
        </clr-dg-column>
        <ng-container *ngIf="isEditingAll" class="col-width">
            <clr-dg-column *ngFor="let row of newRows; let i = index">
                New {{ i + 1 }}
            </clr-dg-column>
        </ng-container>


        <ng-container  *ngFor="let col of columns; let colIndex = index">

        <clr-dg-row *ngIf="col.visible">
            <!-- headers -->
            <clr-dg-cell >
                {{ col.name }}
            </clr-dg-cell>

            <clr-dg-cell *ngIf="defaultData && objectKeys(defaultData).length">
                {{ defaultData[col.field] || 'NA' }}
            </clr-dg-cell>

            <!-- old data -->
            <ng-container *ngIf="data && data.length > 0">
                <clr-dg-cell *ngFor="let row of data; let rowIndex = index">
                    <ng-container *ngIf="isEditingAll">
                        <!-- editing old data -->
                        <ng-container [ngSwitch]="col.type">
                            <select *ngSwitchCase="'boolean'" [(ngModel)]="row[col.field]" class="clr-input"
                                (ngModelChange)="validateField(col.field, col.type,rowIndex,row)">
                                <option [value]="true">True</option>
                                <option [value]="false">False</option>
                            </select>

                            <textarea *ngSwitchCase="'custom'" [(ngModel)]="row[col.field]" class="clr-input"
                                (ngModelChange)="validateField(col.field, col.type,rowIndex,row)">
                            </textarea>

                            <select *ngSwitchCase="'select'" [(ngModel)]="row[col.field]" class="clr-input"
                                (ngModelChange)="validateField(col.field, col.type,rowIndex,row)">
                                <option *ngFor="let option of col.options" [value]="option.value">{{ option.label }}
                                </option>
                            </select>
                            <input *ngSwitchCase="'number'" [(ngModel)]="row[col.field]" [type]="col.type || 'text'"
                                class="clr-input" min=0
                                (ngModelChange)="validateField(col.field, col.type,rowIndex,row)" />

                            <app-gallery [images]="row[col.field]" [isEditing]="true" *ngSwitchCase="'image'"
                                (uploadFiles)="getFilesToUpload($event, col.field, rowIndex)"></app-gallery>

                            <input *ngSwitchDefault [(ngModel)]="row[col.field]" [type]="col.type || 'text'"
                                class="clr-input" (ngModelChange)="validateField(col.field, col.type,rowIndex,row)" />
                        </ng-container>
                        <div *ngIf="errors[rowIndex] && errors[rowIndex][col.field]" class="text-danger">
                            {{ errors[rowIndex][col.field] }}
                        </div>
                    </ng-container>

                    <!-- Display Mode -->
                    <ng-container *ngIf="!isEditingAll">
                        <ng-container [ngSwitch]="col.unit">
                            <ng-container *ngSwitchCase="'percentage'">
                                <span>{{ row[col.field] ? (row[col.field] | number: '1.2-2') + '%' : '0%' }}</span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'currency'">
                                <span>{{formatCurrency(row[col.field])}}</span>
                            </ng-container>

                            <ng-container *ngSwitchCase="'time'">
                                <span>{{ row[col.field] ? (row[col.field] | number: '1.2-2') + 'ms' : '0ms' }}</span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'number'">
                                <span>{{ row[col.field] ? formatNumber(row[col.field]) : 0 }}</span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'date'">
                                <span>{{ row[col.field] ? (row[col.field] | date: 'MM/dd/yyyy') : 'NA' }}</span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'distance'">
                                <span>
                                    {{ row[col.field] ? (row[col.field] | number: '1.2-2') + ' ' + row[col.unit] : 0 }}
                                </span>
                            </ng-container>
                            <ng-container *ngSwitchCase="'custom'">
                                <div [innerHTML]="renderCell({'field': col.field, 'data': row})"></div>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <ng-container *ngIf="col.type != 'image'; else showFile">
                                    <span>{{ row[col.field] || 'NA' }}</span>
                                </ng-container>
                                <ng-template #showFile>
                                    <ng-container *ngIf="row[col.field].length> 0 && row[col.field][0]?.url" else noImages>
                                        <app-gallery [images]="row[col.field]" [isEditing]="false"></app-gallery>
                                    </ng-container>
                                    <ng-template>
                                        <span>No Images</span>
                                    </ng-template>
                                </ng-template>
                            </ng-container>
                        </ng-container>
                    </ng-container>

                </clr-dg-cell>
            </ng-container>

            <!-- new row editing -->
            <ng-container *ngIf="isEditingAll">
                <clr-dg-cell *ngFor="let row of newRows; let rowIndex = index">
                    <ng-container [ngSwitch]="col.type">
                        <select *ngSwitchCase="'boolean'" [(ngModel)]="row[col.field]" class="clr-input"
                            (blur)="onFieldBlur(col.field, col.type, rowIndex, row)">
                            <option [value]="true">True</option>
                            <option [value]="false">False</option>
                        </select>

                        <textarea *ngSwitchCase="'custom'" [(ngModel)]="row[col.field]" class="clr-input"
                            (blur)="onFieldBlur(col.field, col.type, rowIndex, row)">
                    </textarea>

                        <select *ngSwitchCase="'select'" [(ngModel)]="row[col.field]" class="clr-input"
                            (blur)="onFieldBlur(col.field, col.type, rowIndex, row)">
                            <option *ngFor="let option of col.options" [value]="option.value">{{ option.label }}
                            </option>
                        </select>

                        <input *ngSwitchCase="'number'" [(ngModel)]="row[col.field]" [type]="col.type || 'text'"
                            class="clr-input" min="0" (blur)="onFieldBlur(col.field, col.type, rowIndex, row)" />

                        <app-gallery [images]="row[col.field]" [isEditing]="true" *ngSwitchCase="'image'"
                            (uploadFiles)="getFilesToUpload($event, col.field, rowIndex)"></app-gallery>

                        <input *ngSwitchDefault [(ngModel)]="row[col.field]" [type]="col.type || 'text'"
                            class="clr-input" (blur)="onFieldBlur(col.field, col.type, rowIndex, row)" />
                    </ng-container>
                    <div *ngIf="errors?.newRows?.[rowIndex]?.[col.field]" class="text-danger">
                        {{ errors.newRows[rowIndex][col.field] }}
                    </div>
                </clr-dg-cell>
            </ng-container>
        </clr-dg-row>

    </ng-container>
        <clr-dg-row *ngIf="isEditingAll">
            <clr-dg-cell>Actions</clr-dg-cell>
            <clr-dg-cell *ngIf="defaultData && objectKeys(defaultData).length"></clr-dg-cell>

            <clr-dg-cell *ngFor="let row of data; let colIndex = index" style="outline: none !important;">
                <clr-icon shape="trash" class="cursor-pointer text-danger ms-2"
                    (click)="data.splice(colIndex, 1)"></clr-icon>
            </clr-dg-cell>
            <ng-container *ngIf="isEditingAll">
                <clr-dg-cell *ngFor="let row of newRows; let colIndex = index" style="outline: none !important;">
                    <clr-icon shape="trash" class="cursor-pointer text-danger ms-2" *ngIf="colIndex!==newRows.length-1"
                    (click)="newRows.splice(colIndex, 1)"></clr-icon>
                </clr-dg-cell>
            </ng-container>
        </clr-dg-row>
    </clr-datagrid>
</div>
</ng-container>

<!-- horizontal table -->
<div class="table-responsive" *ngIf="!isVerticalTable">
    <clr-datagrid>
        <!-- Headers -->
        <ng-container *ngFor="let col of columns">

            <clr-dg-column *ngIf="col.visible" class="column-width">
                {{ col.name }}
            </clr-dg-column>
        </ng-container>
        <clr-dg-column>Actions</clr-dg-column>

        <!-- Existing Data Rows  -->
        <ng-container *ngIf="data && data.length">
            <clr-dg-row *ngFor="let row of data; let i = index">
                <ng-container *ngFor="let col of columns">
                    <clr-dg-cell *ngIf="col.visible" class="column-width">
                        <!-- editing existing data -->
                        <div *ngIf="isEditingAll">
                            <ng-container [ngSwitch]="col.type">
                                <!-- Boolean -->
                                <select *ngSwitchCase="'boolean'" [(ngModel)]="row[col.field]" class="clr-input"
                                    (ngModelChange)="validateField(col.field, col.type, i, row)">
                                    <option [value]="true">True</option>
                                    <option [value]="false">False</option>
                                </select>

                                <!-- Custom Textarea -->
                                <textarea *ngSwitchCase="'custom'" [(ngModel)]="row[col.field]" class="clr-input"
                                    (ngModelChange)="validateField(col.field, col.type, i, row)">
                                </textarea>

                                <!-- Dropdown -->
                                <select *ngSwitchCase="'select'" [(ngModel)]="row[col.field]" class="clr-input"
                                    (ngModelChange)="validateField(col.field, col.type, i, row)">
                                    <option *ngFor="let option of col.options" [value]="option.value">{{ option.label }}
                                    </option>
                                </select>
                                <!-- Images -->
                                <app-gallery [images]="row[col.field]" [isEditing]="true" *ngSwitchCase="'image'"
                                    (uploadFiles)="getFilesToUpload($event, col.field, i)"></app-gallery>

                                <!-- Default Input -->
                                <input *ngSwitchDefault [(ngModel)]="row[col.field]" [type]="col.type || 'text'"
                                    class="clr-input" (ngModelChange)="validateField(col.field, col.type, i, row)" />
                            </ng-container>

                            <div *ngIf="errors?.[i]?.[col.field]" class="text-danger">
                                {{ errors[i][col.field] }}
                            </div>
                        </div>

                        <!-- View Mode -->
                        <ng-container *ngIf="!isEditingAll">
                            <ng-container [ngSwitch]="col.unit">
                                <ng-container *ngSwitchCase="'percentage'">
                                    <span>{{ row[col.field] ? (row[col.field] | number: '1.2-2') + '%' : '0%' }}</span>
                                </ng-container>
                                <ng-container *ngSwitchCase="'currency'">
                                    <span>{{formatCurrency(row[col.field])}}</span>
                                </ng-container>

                                <ng-container *ngSwitchCase="'time'">
                                    <span>{{ row[col.field] ? (row[col.field] | number: '1.2-2') + 'ms' : '0ms'
                                        }}</span>
                                </ng-container>
                                <ng-container *ngSwitchCase="'number'">
                                    <span>{{ row[col.field] ? formatNumber(row[col.field]) : 0 }}</span>
                                </ng-container>
                                <ng-container *ngSwitchCase="'date'">
                                    <span>{{ row[col.field] ? (row[col.field] | date: 'MM/dd/yyyy') : 'NA' }}</span>
                                </ng-container>
                                <ng-container *ngSwitchCase="'distance'">
                                    <span>
                                        {{ row[col.field] ? (row[col.field] | number: '1.2-2') + ' ' + row[col.unit] : 0
                                        }}
                                    </span>
                                </ng-container>
                                <ng-container *ngSwitchCase="'custom'">
                                    <div [innerHTML]="renderCell({'field': col.field, 'data': row})"></div>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <ng-container *ngIf="col.type != 'image'; else showFile">
                                        <span>{{ row[col.field] || 'NA' }}</span>
                                    </ng-container>
                                    <ng-template #showFile>
                                        <ng-container *ngIf="row[col.field].length> 0 && row[col.field][0]?.url; else noImages">
                                            <app-gallery [images]="row[col.field]" [isEditing]="false"></app-gallery>
                                        </ng-container>
                                        <ng-template #noImages>
                                            <span>No Images</span>
                                        </ng-template>
                                    </ng-template>
                                </ng-container>
                            </ng-container>
                            <!-- <span>{{ row[col.field] || 'NA' }}</span> -->
                        </ng-container>
                    </clr-dg-cell>
                </ng-container>

                <!-- Actions -->
                <clr-dg-cell>
                    <clr-icon shape="trash" class="cursor-pointer text-danger" [ngClass]="!isEditingAll ? 'disabled-icon' : ''"  (click)="openDeleteModal(row)"></clr-icon>
                </clr-dg-cell>
            </clr-dg-row>
        </ng-container>

        <!-- new data  -->
        <ng-container *ngIf="isEditingAll;">
            <clr-dg-row *ngFor="let newrow of newRows; let i = index">
                <ng-container *ngFor="let col of columns">
                <clr-dg-cell  *ngIf="col.visible" class="column-width">
                    <ng-container [ngSwitch]="col.type">
                        <select *ngSwitchCase="'boolean'" [(ngModel)]="newrow[col.field]" class="clr-input"
                            (blur)="onFieldBlur(col.field, col.type, i, newrow)">
                            <option [value]="true">True</option>
                            <option [value]="false">False</option>
                        </select>

                        <textarea *ngSwitchCase="'custom'" [(ngModel)]="newrow[col.field]" class="clr-input"
                            (blur)="onFieldBlur(col.field, col.type, i, newrow)">
                        </textarea>

                        <select *ngSwitchCase="'select'" [(ngModel)]="newrow[col.field]" class="clr-input"
                            (blur)="onFieldBlur(col.field, col.type, i, newrow)">
                            <option *ngFor="let option of col.options" [value]="option.value">{{ option.label }}
                            </option>
                        </select>

                        <!-- images -->
                        <app-gallery [images]="newrow[col.field]" [isEditing]="true" *ngSwitchCase="'image'"
                            (uploadFiles)="getFilesToUpload($event, col.field, i)"></app-gallery>

                        <input *ngSwitchDefault [(ngModel)]="newrow[col.field]" [type]="col.type || 'text'"
                            class="clr-input" (blur)="onFieldBlur(col.field, col.type, i, newrow)" />
                    </ng-container>

                    <div *ngIf="errors?.newRows?.[i]?.[col.field]" class="text-danger">
                        {{ errors.newRows[i][col.field] }}
                    </div>
                </clr-dg-cell>
            </ng-container>

                <!-- Actions -->
                <clr-dg-cell >
                    <clr-icon shape="trash" class="cursor-pointer text-danger" [ngClass]="i===newRows.length-1 ? 'disabled-icon' : ''"
                        (click)="newRows.splice(i, 1)"></clr-icon>
                </clr-dg-cell>
            </clr-dg-row>
        </ng-container>
        <ng-container *ngIf="!data?.length && !isEditingAll">
            <clr-dg-row>
                <clr-dg-cell [attr.colspan]="columns?.length+1" class="text-center w-auto">
                    No Data Available
                </clr-dg-cell>
            </clr-dg-row>
        </ng-container>
    </clr-datagrid>
</div>



<!-- Delete modal -->
<clr-modal [(clrModalOpen)]="isDeleteModalOpen">
    <h3 class="modal-title">Confirm Delete</h3>
    <div class="modal-body">
        <p>Are you sure you want to delete this data?</p>
    </div>
    <div class="modal-footer">
        <button class="btn btn-danger" (click)="confirmDelete()">Delete</button>
        <button class="btn btn-outline" (click)="isDeleteModalOpen = false">Cancel</button>
    </div>
</clr-modal>


<div class="setting-modal">

    <clr-modal [(clrModalOpen)]="isImportModalOpen" [clrModalSize]="'full-screen'">
        <h3 class="modal-title">Import Data</h3>
        <div class="modal-body">
            <app-custom-import-filters *ngIf="isImportModalOpen" (closeModal)="closeImportModal()"  [schemaName]="schemaName"[columns]="columns"
                (applyFilters)="onFilterApply($event)" (selectedPropertiesChange)="getSelectedComps($event)" 
                [totalCount]="totalCount" [pageSize]="pageSize" [offset]="(currentPage - 1) * pageSize"  [onCellRender]="onCellRender"
                (pageChange)="onPageChanged($event)"  [propertyDetail]="propertyDetail"  [selectedProperties]="this.selectedComps" (loadMore)="fetchMore()"></app-custom-import-filters>

        </div>
        <div class="modal-footer">
            <button class="btn btn-primary" (click)="addComparable()">Submit</button>
            <button class="btn btn-outline ms-2" (click)="closeImportModal()">Cancel</button>
        </div>
    </clr-modal>
</div>